export enum WorkExperiencTypeEnum{
    Mandatory = 1,
    WithoutExperience = 2,
    WithExperience = 3
}